import { Meta, Link } from "@solidjs/meta";
import { useLocale } from "~/context/locale";
import PageTitle, { SITE_NAME } from "./PageTitle";

const BASE = "https://lyszt.net";
const OG_LOCALE = {
  en: "en_US",
  fr: "fr_FR",
  pt: "pt_BR",
  de: "de_DE",
  it: "it_IT",
  es: "es_ES",
  pl: "pl_PL",
  ru: "ru_RU",
  uk: "uk_UA",
  ja: "ja_JP",
  ko: "ko_KR",
  zh: "zh_CN",
  ar: "ar_SA",
  hi: "hi_IN",
};

export default function Seo(props) {
  const { locale, prefix } = useLocale();
  const url = () => `${BASE}${prefix}${props.path ?? ""}`;
  return (
    <>
      <PageTitle title={props.title} />
      <Link rel="canonical" href={url()} />
      <Meta name="description" content={props.description} />
      <Meta property="og:title" content={props.title} />
      <Meta property="og:description" content={props.description} />
      <Meta property="og:type" content={props.type ?? "website"} />
      <Meta property="og:url" content={url()} />
      <Meta property="og:locale" content={OG_LOCALE[locale] ?? "en_US"} />
      <Meta property="og:site_name" content={SITE_NAME} />
      <Meta property="og:image" content={`${BASE}/og.png`} />
      <Meta property="og:image:width" content="1200" />
      <Meta property="og:image:height" content="630" />
      <Meta property="og:image:alt" content={props.title} />
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content={props.title} />
      <Meta name="twitter:description" content={props.description} />
      <Meta name="twitter:image" content={`${BASE}/og.png`} />
      {props.ld && (
        // eslint-disable-next-line solid/no-innerhtml
        <script type="application/ld+json" innerHTML={JSON.stringify(props.ld)} />
      )}
    </>
  );
}
